var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.brandCollection)?_c('router-link',{attrs:{"to":{name: 'Collection', params: {id: _vm.brandCollection.id}}}},[_vm._v(" "+_vm._s(_vm.brandCollection.name)+" ")]):_c('span',[_vm._v(_vm._s(_vm.$t('common.misc.NA')))])
}
var staticRenderFns = []

export { render, staticRenderFns }